import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Cart from "./images/Cart.png"
import { useTranslation } from 'react-i18next';
import {jwtDecode} from "jwt-decode";

const getSessionCartCount = () => {
  const cart = JSON.parse(sessionStorage.getItem("cart")) || [];
  return cart.reduce((total, item) => total + item.quantity, 0);
};

const CartButton = () => {
  const [itemCount, setItemCount] = useState(0);
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/";
  const { t } = useTranslation();

  const token = localStorage.getItem("token");
  let userId = null;
  if (token) {
    try {
      const decoded = jwtDecode(token);
      userId = decoded.userId;
    } catch (err) {
      console.error("Invalid token:", err);
    }
  }

  useEffect(() => {
    const fetchCartCount = async () => {
      try {
        const res = await fetch(`${API_URL}cart/${userId}`);
        const data = await res.json();
        if (res.ok) {
          const totalItems = data.cart.reduce((sum, item) => sum + item.quantity, 0);
          setItemCount(totalItems);
        }
      } catch (err) {
        console.error("Error fetching cart count:", err);
      }
    };

    if (userId) {
      fetchCartCount();
    } else {
      setItemCount(getSessionCartCount());
    }

    const handleCartUpdated = () => {
      if (userId) {
        fetchCartCount();
      } else {
        setItemCount(getSessionCartCount());
      }
    };

    window.addEventListener("cartUpdated", handleCartUpdated);

    return () => {
      window.removeEventListener("cartUpdated", handleCartUpdated);
    };
  }, [API_URL, userId]);

  const handleClick = () => {
    if (userId) {
      navigate(`/cart/${userId}`);
    } else {
      const sessionCart = JSON.parse(sessionStorage.getItem("cart")) || [];
      navigate("/cart/guest", { state: { cartItems: sessionCart } });
    }
  };

  return (
    <BtnDiv>
      <CartBtn onClick={handleClick}>
        <IMG src={Cart} />
        {t('Cart')} <span>({itemCount})</span>
      </CartBtn>
    </BtnDiv>
  );
};

export default CartButton;

const BtnDiv = styled.div`
display: flex;

`

const IMG = styled.img`
  width: 34px;
  vertical-align: middle;
  padding-bottom: 5px;
  padding-right: 3px;
`;


const CartBtn = styled.button`
  background-color: rgba(186,204,171,1);
  box-shadow: 0 4px 24px white;
  color: black;
  border: none;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 18px;
  cursor: pointer;

  span {
    font-weight: bold;
  }

  &:hover {
    background-color: rgba(148,163,135,1);
  }
`;